<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">老人</div>
                        <el-input v-model="elderlyName" disabled></el-input>
                    </el-col>
                </el-row>
              <el-row class="row">
                <el-col :span="24" class="item">
                  <div class="label">药品</div>
                  <el-input v-model="remarks" type="textarea"></el-input>
                </el-col>
              </el-row>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading"  type="primary" @click.native="confirm">确认</el-button>
            </div>
        </div>

    </div>
</template>


<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: 'Edit',
        props: [],
        data() {
            return {

                loading: false,

                elderlyName:'',

              remarks:'',
                elderlyDrugRecordCode:'',


            }
        },
        methods: {
            init(row){

                this.elderlyName = row.elderlyName;
                this.remarks = row.remarks;
                this.elderlyDrugRecordCode = row.elderlyDrugRecordCode;

            },

            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(){
              if(this.remarks === ''){
                return;
              }

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'ElderlyDrugRecord/Edit',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        remarks:this.remarks,
                        elderlyDrugRecordCode:this.elderlyDrugRecordCode,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.$emit("closeEdit");
                        this.$emit("getList");
                    }else{
                        this.$message(response.data.message);
                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },



        }
    }
</script>


<style  lang="scss" scoped >


</style>
